import React, { Component } from 'react';

import {ProgressBar} from 'react-bootstrap';
import { DirectUpload } from '../../PathedLibs/activestorage'
import {Rest, backend_url} from "../../Helpers/Rest" 
import InfoBlock from '../../Components/InfoBlock/InfoBlock'
import PropTypes from 'prop-types';


export default class DirectUploadComponent extends React.Component {
    state = {
        progress: 0
    }

    directUploadWillStoreFileWithXHR(request) { 
        request.upload.addEventListener("progress", event => this.directUploadDidProgress(event))
    }
    
    directUploadDidProgress(event) {
        this.setState({
            progress: Math.round(event.loaded/event.total * 100)     
        })     
    }

    componentDidMount = () => {
        const upload_url = backend_url+"rails/active_storage/direct_uploads" 
        const upload = new DirectUpload(this.props.file, upload_url, this)

        upload.create((error, blob) => {
            if (error) { 
              //console.log(error)
              alert("Ошибка загрузки файла "+error)
            } else {
              //console.log(blob)
              var rest = new Rest(this)
              rest.request('uploads', 'CREATE', { 
                blob_id: blob.signed_id, 
                name: this.props.name, 
                description: this.props.description, 
                table_name: this.props.table_name, 
                record_id: this.props.record_id, 
                variant: this.props.variant
              }, (res)=>{
                  this.props.onSuccess(this.props.file)
              })          
            }
          })  
    };

    
    
  render() {
    return (
      <div> DirectUpload {this.state.progress}%
        {
                this.state.errors && <InfoBlock data={this.state.errors} variant="danger" />
            }
      </div>
    );
  }
}


DirectUploadComponent.propTypes = { 
    variant: PropTypes.string,
    description: PropTypes.string,
    table_name: PropTypes.string,
    name: PropTypes.string,
    record_id: PropTypes.integer,
    file: PropTypes.object,
    onSuccess: PropTypes.func,
}